module.exports = __webpack_public_path__ + "static/media/usa-icon.7356f994.jpg";